
import React from "react";

import { IconProps } from "../Icon.types";

const ServiceIcon: React.FC<IconProps> = ({ colourFill }) => {

    return (
        <svg width="76" height="76" viewBox="0 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M42.61 53.03L44 21H10L11.84 63.17C11.9291 65.3094 13.6887 66.9985 15.83 67H42" stroke={colourFill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M42 67C45.866 67 49 63.866 49 60C49 56.134 45.866 53 42 53C38.134 53 35 56.134 35 60C35 63.866 38.134 67 42 67Z" stroke={colourFill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M42 63C43.6569 63 45 61.6569 45 60C45 58.3431 43.6569 57 42 57C40.3431 57 39 58.3431 39 60C39 61.6569 40.3431 63 42 63Z" stroke={colourFill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path fillRule="evenodd" clipRule="evenodd" d="M8 17H47V19C47 20.1046 46.1046 21 45 21H8C6.89543 21 6 20.1046 6 19C6 17.8954 6.89543 17 8 17Z" stroke={colourFill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path fillRule="evenodd" clipRule="evenodd" d="M13 13H45C46.1046 13 47 13.8954 47 15V17H9C9 14.7909 10.7909 13 13 13Z" stroke={colourFill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path fillRule="evenodd" clipRule="evenodd" d="M23 9H31C32.1046 9 33 9.89543 33 11V13H21V11C21 9.89543 21.8954 9 23 9Z" stroke={colourFill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path fillRule="evenodd" clipRule="evenodd" d="M47 15H51C52.1046 15 53 15.8954 53 17C53 18.1046 52.1046 19 51 19H47V15Z" stroke={colourFill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M34.0001 41.1231C33.9975 44.2075 31.9747 46.9262 29.021 47.8148C26.0674 48.7035 22.8803 47.5524 21.1761 44.9815C19.472 42.4105 19.6532 39.0268 21.6222 36.6525C23.5911 34.2783 26.8829 33.4741 29.7248 34.6732" stroke={colourFill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path fillRule="evenodd" clipRule="evenodd" d="M30.9048 33L28.6348 37.378L33.0538 36.892L30.9048 33Z" stroke={colourFill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>



    )
} 


export default ServiceIcon;

